import { render, staticRenderFns } from "./sixToast.vue?vue&type=template&id=22ae8421&scoped=true&"
import script from "./sixToast.vue?vue&type=script&lang=js&"
export * from "./sixToast.vue?vue&type=script&lang=js&"
import style0 from "./sixToast.vue?vue&type=style&index=0&id=22ae8421&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ae8421",
  null
  
)

export default component.exports